    /* eslint-disable @typescript-eslint/no-explicit-any */
import {useFormik} from "formik";
import {useDispatch, useSelector,} from "react-redux";
import {notification} from "@/store/modules/notification";
import {StoreUtil} from "@/util/store/StoreUtil";
import {BaseInput} from "../input/BaseInput";
import {RootState} from "@/store/modules";
import {BaseSelect} from "../input/BaseSelect.tsx";
import {ReadEntity} from "@/model/response/entity/ReadEntityResponse.ts";
import {useEffect, useState} from "react";
import {entity} from "@/store/modules/entity.ts";
import {authConfig} from "@/store/modules/authConfig.ts";
import {
    CreateAuthConfigRequest,
    CreateAuthConfigRequestInit
} from "@/model/request/authConfig/CreateAuthConfigRequest.ts";
import {attribute} from "@/store/modules/attribute.ts";
import {base} from "@/store/modules/base.ts";
import {BaseModal} from "@/components/modal/BaseModal.tsx";


export default function AuthConfigModal() {
    const dispatch = useDispatch<any>();
    const AuthConfigState = useSelector((state: RootState) => state.authConfig)
    const EntityState = useSelector((state: RootState) => state.entity)
    const ApplicationState = useSelector((state: RootState) => state.application)
    const filteredEntity = EntityState.entity.filter((entity: ReadEntity) => entity.entityApplicationId === ApplicationState.selectedApplication?.applicationId)
    const items = [{value: "", label: "Select Option"}, {value: "Yes", label: "Yes"}, {value: "No", label: "No"}]
    const attributeState = useSelector((state: RootState) => state.attribute)
    const [selectedValue, setSelectedValue] = useState("")

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedLabel = event.target.options[event.target.selectedIndex].label
        setSelectedValue(selectedLabel);
        const selectedValue = Number(event.target.value);
        dispatch(attribute.action.readAttributeByEntityId({attributeEntityId: selectedValue}));
    };


    useEffect(() => {
        dispatch(entity.action.read())
    }, []);
    const showErrorMessage = (response: any) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: "error",
                        title: "Error",
                        body: response.responseMessage,
                    })
                )
                formik.resetForm();
            }
        );
        dispatch(base.mutation.resetModalOptions())
    };


    const showSuccessMessage = (response: any) => {
        StoreUtil.execute(() => {
            dispatch(
                notification.mutation.openModal({
                    type: "success",
                    title: "Success",
                    body: response.responseMessage,
                })
            )
            dispatch(base.mutation.resetModalOptions())
        })
    };
    const handleSubmit = async (value: CreateAuthConfigRequest) => {
        const request = {
            ...value,
            authenticationConfigUserEntity: selectedValue,
            authenticationConfigApplicationId: ApplicationState.selectedApplication?.applicationId
        };
        await dispatch(
            authConfig.action.create({
                data: request,
                onSuccess: (response: any) => {
                    showSuccessMessage(response)
                },
                onError: (response: any) => showErrorMessage(response),
            })
        )
        formik.resetForm();
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: CreateAuthConfigRequestInit,
    });
    return (
            <BaseModal size={"md"} subtitle={"Add Authentication to your application"}
                       title={"Create Authentication Config"}>
                <div style={{
                    backgroundColor: "white",
                    borderRadius: "9px",
                    height: "30rem",
                    overflow: "scroll"
                }}>
                    <div>
                        <div className="workspace-content">
                            <form onSubmit={formik.handleSubmit}>
                                <div>
                                    <div className="flex-2">
                                        <div className="flex-item">
                                            <label>Send Email</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigSendEmail"
                                                data-name="authenticationConfigSendEmail"
                                                id="authenticationConfigSendEmail"
                                                items={items}
                                            />
                                        </div>
                                        <div className="flex-item">
                                            <label>Send SMS</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigSendSms"
                                                data-name="authenticationConfigSendSms"
                                                id="authenticationConfigSendSms"
                                                items={items}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex-2">
                                        <div className="flex-item">
                                            <label>Generate OTP</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigGenerateOtp"
                                                id="authenticationConfigGenerateOtp"
                                                items={items}
                                            />
                                        </div>
                                        <div className="flex-item">
                                            <label>Generate Link</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigGenerateLink"
                                                id="authenticationConfigGenerateLink"
                                                items={items}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex-2">
                                        <div className="flex-item">
                                            <label>Is Password Encrypted</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigIsPasswordEncrypted"
                                                items={items}
                                            />
                                        </div>
                                        <div className="flex-item">
                                            <label>Non-Reusable Recent</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigNonReusableRecentPassword"
                                                id="authenticationConfigNonReusableRecentPassword"
                                                items={items}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex-2">
                                        <div className="flex-item">
                                            <label>User Entity</label>
                                            <select className="form_input w-select"
                                                    onChange={handleChange}
                                                    name={"authenticationConfigUserEntity"}>
                                                <option value={""}>Select User Entity</option>
                                                {filteredEntity.map(item =>
                                                    <option value={item.entityId}>{item.entityName}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className="flex-item">
                                            <label>RoleId Attribute</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigRoleIdAttribute"
                                                id="authenticationConfigRoleIdAttribute"
                                                items={[
                                                    {value: "", label: "Choose Username Attribute"},
                                                    ...attributeState.attributeById?.map(it => {
                                                        return {
                                                            label: it.attributeName,
                                                            value: it.attributeName
                                                        }
                                                    }) ?? []
                                                ]}
                                                disabled={attributeState.loading}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex-2">
                                        <div className="flex-item">
                                            <label>Password Attribute</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigPasswordAttribute"
                                                id="authenticationConfigPasswordAttribute"
                                                items={[
                                                    {value: "", label: "Choose Password Attribute"},
                                                    ...attributeState.attributeById?.map(it => {
                                                        return {
                                                            label: it.attributeName,
                                                            value: it.attributeName
                                                        }
                                                    }) ?? []
                                                ]}
                                                disabled={attributeState.loading}
                                            />
                                        </div>
                                        <div className="flex-item">
                                            <label>Username Attribute</label>
                                            <BaseSelect
                                                formik={formik}
                                                className="form_input w-select"
                                                name="authenticationConfigUsernameAttribute"
                                                id="authenticationConfigUsernameAttribute"
                                                items={[
                                                    {value: "", label: "Choose Username Attribute"},
                                                    ...attributeState.attributeById?.map(it => {
                                                        return {
                                                            label: it.attributeName,
                                                            value: it.attributeName
                                                        }
                                                    }) ?? []
                                                ]}
                                                disabled={attributeState.loading}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex btns">
                                    <a className="button is-secondary w-button"
                                       onClick={() => dispatch(base.mutation.resetModalOptions())}>Cancel</a>
                                    <BaseInput
                                        type="submit"
                                        formik={formik}
                                        name={"submit"}
                                        value={"Create Auth Config"}
                                        loading={AuthConfigState.loading}
                                        className="button w-button"
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </BaseModal>
    );
}

